import { createSlice } from "@reduxjs/toolkit";
import { getLocalStorage, setLocalStorage } from "../../../helperFunctions/localStorage";

const initialState: any = {
  appVersion: getLocalStorage("appVersion") || "",
};

const crashAnalyticsSlice = createSlice({
  name: "crashAnalytics",
  initialState,
  reducers: {
    setCrashAnalytics(state, action) {
      setLocalStorage("appVersion", action.payload.appVersion || "");
      return { ...state, appVersion: action.payload.appVersion || "" };
    },
  },
});

export const { setCrashAnalytics } = crashAnalyticsSlice.actions;
export default crashAnalyticsSlice.reducer;
